// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1cHKU","productName":"Table_productName__2IWuZ"};